import * as R from 'ramda'
import { Skeleton, Typography, TypographyProps } from '@mui/material'
import { escapeRegExp } from '$helper/functions/utils'
import { ClampedTypography } from '$common/clamped-typography'

interface Props extends TypographyProps {
  query: string
  title: string
  variant: 'subtitle3' | 'caption1'
  direction?: 'rtl' | 'ltr' | 'inherit' | undefined
  maxLines?: number
}

export function WithQueryTitleBase({
  query,
  title,
  variant,
  direction = 'inherit',
  maxLines = 1,
  ...other
}: Props) {
  if (!title) return <Skeleton variant="text" />
  const regex = new RegExp(escapeRegExp(query), 'ig')
  const splitTitle = query ? R.split(regex, title) : [title]

  const matchedTitle = [...R.match(regex, title)]

  return (
    <ClampedTypography
      sx={{
        ...other.sx,
        direction,
      }}
      maxLines={maxLines}
      variant={variant}
      {...other}
    >
      {splitTitle.map((_, index) => (
        <>
          <Typography component="span" variant="inherit" color="inherit">
            {splitTitle[index]}
          </Typography>

          {matchedTitle[index] ? (
            <Typography
              component="span"
              variant="inherit"
              color="secondary.main"
            >
              {matchedTitle[index]}
            </Typography>
          ) : null}
        </>
      ))}
    </ClampedTypography>
  )
}
